// all styles here
import "./src/assets/css/bootstrap.min.css"
import "./src/assets/css/animate.min.css"
import "./src/assets/css/boxicons.min.css"
import "./src/assets/css/flaticon.css"
import './node_modules/react-modal-video/css/modal-video.min.css'
import 'react-accessible-accordion/dist/fancy-example.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'aos/dist/aos.css'
import "./src/assets/css/style.css"
import "./src/assets/css/landing.css"
import "./src/assets/css/responsive.css"
import React from "react";
import AOS from 'aos';
import {
  bindInstantAnchorScroll,
  scrollToRouteHash,
} from "./src/utils/instantScrollToAnchor";
import { trackPageView } from "./src/utils/analytics";

export const onClientEntry = () => {
    AOS.init({ duration: 800, once: true });
    bindInstantAnchorScroll();
}

export const onRouteUpdate = ({ location, prevLocation }) => {
    scrollToRouteHash(location.hash);

    // Gatsby chiama onRouteUpdate anche al primo load: evitiamo page_view duplicata
    // sul primo load (GA4/GTM gestiscono il pageview iniziale in base a consenso e config tag).
    if (!prevLocation) return;

    trackPageView(window.location);
};

export const wrapPageElement = ({element, props}) => {
    return element
}
